import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  Typography,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BarChartIcon from '@mui/icons-material/BarChart';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import SavingsIcon from '@mui/icons-material/Savings';
import EventNoteIcon from '@mui/icons-material/EventNote';
import SettingsIcon from '@mui/icons-material/Settings';

const navItems = [
  { label: 'Dashboard', icon: <DashboardIcon />, path: '/', enabled: true },
  { label: 'Upload Data', icon: <CloudUploadIcon />, path: '/upload', enabled: true },
  { label: 'Budget', icon: <AccountBalanceWalletIcon />, path: '/budget', enabled: true },
  { label: 'Budget Plan', icon: <EventNoteIcon />, path: '/budget-plan', enabled: true },
  { label: 'Savings', icon: <SavingsIcon />, path: '/savings', enabled: true },
  { label: 'Analytics', icon: <BarChartIcon />, path: '/analytics', enabled: true },
  { label: 'Transactions', icon: <ReceiptLongIcon />, path: '/transactions', enabled: false },
];

const bottomItems = [
  { label: 'Settings', icon: <SettingsIcon />, path: '/settings', enabled: true },
];

export default function Sidebar({ onClose }) {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNav = (path, enabled) => {
    if (!enabled) return;
    navigate(path);
    if (onClose) onClose();
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ p: 2 }}>
        <Typography variant="h6" color="primary" fontWeight={700}>
          Family Budget
        </Typography>
        <Typography variant="caption" color="text.secondary">
          WadeDahl Family
        </Typography>
      </Box>
      <Divider />
      <List sx={{ flex: 1, pt: 1 }}>
        {navItems.map((item) => (
          <ListItemButton
            key={item.path}
            selected={location.pathname === item.path}
            onClick={() => handleNav(item.path, item.enabled)}
            disabled={!item.enabled}
            sx={{
              mx: 1,
              borderRadius: 1,
              mb: 0.5,
              '&.Mui-selected': {
                backgroundColor: 'primary.light',
                color: 'white',
                '& .MuiListItemIcon-root': { color: 'white' },
                '&:hover': { backgroundColor: 'primary.main' },
              },
            }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>
      <Divider />
      <List>
        {bottomItems.map((item) => (
          <ListItemButton
            key={item.path}
            selected={location.pathname === item.path}
            onClick={() => handleNav(item.path, item.enabled)}
            disabled={!item.enabled}
            sx={{ mx: 1, borderRadius: 1 }}
          >
            <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
            <ListItemText primary={item.label} />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
}
